import CompletedSurvey from './CompletedSurvey';

export default CompletedSurvey;
